import { Controller, useForm } from 'react-hook-form';
import Drawer from '../../../../../components/Drawer';
import { FormElement } from '../../../Funds/components/Jurisdictions/style';
import { Form, Label } from './style';
import { BadgeContainer, Footer, SelectBadge } from '../../style';
import Button from '../../../../../components/Button';
import ChevronRightIcon from '../../../../../assets/icons/chevron-right.svg?react';
import { useEffect } from 'react';
import { getYearsForLastFiveYears } from '../../../../../utils';

const periodOptions = ['Q1', 'Q2', 'Q3', 'Q4', 'H1', 'H2', 'Y1', 'X1', 'X2'];
const years = getYearsForLastFiveYears();

export const GenerateAIFMReportDrawer = ({
  isOpen,
  onClose,
  onSubmit,
  defaultValues,
  isLoading
}) => {
  const { control, reset, handleSubmit } = useForm({
    defaultValues
  });

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, isOpen]);

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      title={'Generate Multi-AIFM Report'}
      style={{
        maxWidth: 410,
        minWidth: 410
      }}
    >
      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormElement>
          <Label>Select Period</Label>
          <Controller
            name="period"
            control={control}
            render={({ field: { value, onChange } }) => (
              <BadgeContainer>
                {periodOptions.map((year, yId) => (
                  <SelectBadge
                    key={yId}
                    active={year === value}
                    onClick={() => onChange(year)}
                    type="button"
                  >
                    {year}
                  </SelectBadge>
                ))}
              </BadgeContainer>
            )}
          />
        </FormElement>

        <FormElement>
          <Label>Select Year</Label>
          <Controller
            name="year"
            control={control}
            render={({ field: { value, onChange } }) => (
              <BadgeContainer>
                {years.map((year, yId) => (
                  <SelectBadge
                    key={yId}
                    active={year === value}
                    onClick={() => onChange(year)}
                    type="button"
                  >
                    {year}
                  </SelectBadge>
                ))}
              </BadgeContainer>
            )}
          />
        </FormElement>

        <Footer>
          <Button size="sm" rightIcon={<ChevronRightIcon />} type="submit">
            {isLoading ? 'Generating...' : 'Generate'}
          </Button>
        </Footer>
      </Form>
    </Drawer>
  );
};
